import { render, staticRenderFns } from "./demandSalesCard.vue?vue&type=template&id=502463b8&scoped=true"
import script from "./demandSalesCard.vue?vue&type=script&lang=ts"
export * from "./demandSalesCard.vue?vue&type=script&lang=ts"
import style0 from "./demandSalesCard.vue?vue&type=style&index=0&id=502463b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502463b8",
  null
  
)

export default component.exports